import { getCurrentAppVersion } from "./versionInfo";

/**
 * API base URL configuration.
 * 
 * ============================================================
 * DUAL-AUTH ARCHITECTURE (DO NOT CHANGE):
 * ============================================================
 * Web:
 *   - Uses relative "/api" → same-origin → no CORS needed.
 *   - Auth via httponly cookies (set by backend).
 * 
 * Capacitor Native (iOS/Android):
 *   - Uses full hosted URL (cross-origin to capacitor://localhost).
 *   - Auth via Authorization: Bearer <token> header.
 *   - Native bootstrap/login requests may briefly use secure cookies so the
 *     app can sync a native-only refresh path without exposing refresh tokens
 *     back into normal JS state.
 *   - See tokenManager.js and CompanionBridge for the native token flow.
 * ============================================================
 */

const HOSTED_BACKEND = "https://cacaradar.es";

function getApiUrl() {
  if (typeof window !== "undefined") {
    const isNative = window.Capacitor?.isNativePlatform?.() ||
      window.location?.protocol === "capacitor:" ||
      window.location?.protocol === "ionic:";
    if (isNative) {
      return HOSTED_BACKEND + "/api";
    }
  }
  return "/api";
}

export const API = getApiUrl();
export const HOSTED_WEB_URL = HOSTED_BACKEND;
export const APP_ENVIRONMENT = API.startsWith("http") ? "native-production" : "web";
export const APP_VERSION = process.env.REACT_APP_VERSION || getCurrentAppVersion();
export const NATIVE_PUSH_ENABLED = process.env.REACT_APP_ENABLE_NATIVE_PUSH !== "false";
export const GOOGLE_CLIENT_ID =
  process.env.REACT_APP_GOOGLE_CLIENT_ID ||
  "685896513137-l455qbtk0bsgkuhlfiihc1bd0q5o1jia.apps.googleusercontent.com";
export const GOOGLE_IOS_CLIENT_ID =
  process.env.REACT_APP_GOOGLE_IOS_CLIENT_ID ||
  "685896513137-h75c4t1ikftjofpl6vovakoj4f6vgn1l.apps.googleusercontent.com";
export const APPLE_WEB_CLIENT_ID = process.env.REACT_APP_APPLE_CLIENT_ID || "";
export const APPLE_WEB_REDIRECT_URI = process.env.REACT_APP_APPLE_REDIRECT_URI || "";
export const APPLE_IAP_PREMIUM_MONTHLY_PRODUCT_ID =
  process.env.REACT_APP_APPLE_IAP_PREMIUM_MONTHLY_PRODUCT_ID || "com.jefe.cacaradar.monthly";
export const APPLE_IAP_PREMIUM_ANNUAL_PRODUCT_ID =
  process.env.REACT_APP_APPLE_IAP_PREMIUM_ANNUAL_PRODUCT_ID || "com.jefe.cacaradar.yearly";
export const GOOGLE_PLAY_PREMIUM_MONTHLY_PRODUCT_ID =
  process.env.REACT_APP_GOOGLE_PLAY_PREMIUM_MONTHLY_PRODUCT_ID || "com.jefe.cacaradar.monthly";
export const GOOGLE_PLAY_PREMIUM_ANNUAL_PRODUCT_ID =
  process.env.REACT_APP_GOOGLE_PLAY_PREMIUM_ANNUAL_PRODUCT_ID || "com.jefe.cacaradar.yearly";
export const APPLE_IAP_MUNICIPAL_BASIC_PRODUCT_ID =
  process.env.REACT_APP_APPLE_IAP_MUNICIPAL_BASIC_PRODUCT_ID || "com.jefe.cacaradar.municipal.basic.yearly";
export const APPLE_IAP_MUNICIPAL_PLUS_PRODUCT_ID =
  process.env.REACT_APP_APPLE_IAP_MUNICIPAL_PLUS_PRODUCT_ID || "com.jefe.cacaradar.municipal.plus.yearly";
export const APPLE_IAP_MUNICIPAL_PRO_PRODUCT_ID =
  process.env.REACT_APP_APPLE_IAP_MUNICIPAL_PRO_PRODUCT_ID || "com.jefe.cacaradar.municipal.pro.yearly";
export const GOOGLE_PLAY_MUNICIPAL_BASIC_PRODUCT_ID =
  process.env.REACT_APP_GOOGLE_PLAY_MUNICIPAL_BASIC_PRODUCT_ID || "com.jefe.cacaradar.municipal.basic";
export const GOOGLE_PLAY_MUNICIPAL_PLUS_PRODUCT_ID =
  process.env.REACT_APP_GOOGLE_PLAY_MUNICIPAL_PLUS_PRODUCT_ID || "com.jefe.cacaradar.municipal.plus";
export const GOOGLE_PLAY_MUNICIPAL_PRO_PRODUCT_ID =
  process.env.REACT_APP_GOOGLE_PLAY_MUNICIPAL_PRO_PRODUCT_ID || "com.jefe.cacaradar.municipal.pro";
export const PLAY_INTEGRITY_ENABLED = process.env.REACT_APP_ENABLE_PLAY_INTEGRITY === "true";
export const PLAY_INTEGRITY_CLOUD_PROJECT_NUMBER = process.env.REACT_APP_GOOGLE_CLOUD_PROJECT_NUMBER || "";
export const SPAIN_LOCATION_GATE_ENABLED = process.env.REACT_APP_ENABLE_SPAIN_LOCATION_GATE !== "false";
